import icons from '../../../../assets/svg/index';
import SelectedItemIcon from '../../../../assets/svg/ply-kitted.svg';
import cn from 'classnames';

require('./moveAssetsListItem.scss');

const assetsTypes = {
  ROLL : {
    icon: icons.rollSmall,
    paramName: 'material'
  },
  SPOOL : {
    icon: icons.spool,
    paramName: 'material'
  },
  RESIN : {
    icon: icons.resin,
    paramName: 'material'
  },
  KIT : {
    icon: icons.kitSmall,
    paramName: 'kitType'
  },
  TOOL : {
    icon: icons.toolSmall,
    paramName: 'toolType'
  },
  GROUP : {
    icon: icons.groupSmall,
    paramName: 'groupType'
  },
}

export default function MoveAssetsListItem ({ asset = {},
                                              onClickHCallback= null,
                                              onAssetClickCallback = null,
                                            })
{

  const onAssetClick = (e) => {
    e.stopPropagation();
    onAssetClickCallback?.(asset.id);
  };

  const renderAsset = () => {
    const details = assetsTypes[asset?.objectType]?.paramName ?? '';
    const Icon = asset.selected ? SelectedItemIcon : assetsTypes[asset?.objectType]?.icon ?? '';

    return (
      <div className={cn('move-assets-list-item', {selected: asset.selected})} onClick={() => onClickHCallback?.(asset.id)}>
        <div className="section asset-icon">
          <Icon/>
        </div>
        <div className="section asset-info">
          <div className="section asset-id">
            <div onClick={onAssetClick}>{asset.businessId}</div>
          </div>
          <div className="section material-type">
            <label>{asset[details]?.businessId}</label>
          </div>
        </div>
      </div>
    )
  }

  return asset ? renderAsset() : null;
}

MoveAssetsListItem.propTypes = {};


